<template>
	<div>
		<h1 class="page-header"><i class="fa-solid fa-money-bill"></i> Pénzügyek <small></small></h1>
		<hr>
		<panel title="lemondott foglalások">
			<Loading v-if="!cancelled_bookings"></Loading>
			<NoRecords v-else-if="cancelled_bookings.length == 0" main_icon="fa-solid fa-calendar-xmark" title="nincsenek lemondott foglalások"></NoRecords>
			<div class="table-responsive" v-else>
				<button type="button" class="btn btn-green mb-2" @click="downloadExcel"><i class="fa-solid fa-file-excel"></i> Excel letöltése</button>
				<vue-good-table
					:columns="c_columns" 
					:rows="cancelled_bookings" 
					:lineNumbers="true"
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
					:pagination-options="{
						enabled: true, 
						position: 'bottom',

					}"
				>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'actions'">
							<button @click="confirmRefund(props.row.id)" class="btn btn-indigo btn-xs mx-1" title="visszautalva"><i class="fa-solid fa-arrow-right-arrow-left"></i> Visszautalva</button>
						</span>
						<span v-else-if="props.column.field == 'price' || props.column.field == 'refund_amount'">
							{{props.formattedRow[props.column.field].toLocaleString()}} Ft	
						</span>
						<span v-else>
							{{props.formattedRow[props.column.field]}}
						</span>
					</template>
				</vue-good-table>
			</div>
		</panel>
		<panel title="befizetésre váró foglalások">
			<Loading v-if="!unpaid_bookings"></Loading>
			<NoRecords v-else-if="unpaid_bookings.length == 0" main_icon="fa-solid fa-calendar-xmark" title="nincsenek befizetésre váró foglalások"></NoRecords>
			<div class="table-responsive" v-else>
				<vue-good-table
					:columns="columns" 
					:rows="unpaid_bookings" 
					:lineNumbers="true"
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
					:pagination-options="{
						enabled: true, 
						position: 'bottom',

					}"
				>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'actions'">
							<button @click="confirmPaid(props.row.id)" class="btn btn-blue btn-xs mx-1" title="fizetve"><i class="fa-solid fa-arrow-right-arrow-left"></i> Átutalással fizetett</button>
						</span>
						<span v-else-if="props.column.field == 'id'">
							<router-link class="btn btn-black btn-xs" style="text-decoration:none;" :to="'/bookings/'+props.row.id">#{{props.row.id}}</router-link>
						</span>
						<span v-else-if="props.column.field == 'price'">
							{{props.formattedRow[props.column.field].toLocaleString()}} Ft	
						</span>
						<span v-else>
							{{props.formattedRow[props.column.field]}}
						</span>
					</template>
				</vue-good-table>
			</div>
		</panel>
	</div>
</template>

<script>
	import Booking from '../../apis/Booking'
	import Confirmation from '../../apis/Confirmation'
	export default {
		data() {
			return {
				unpaid_bookings:null,
				cancelled_bookings:null,
				columns: [
					{
						label: 'Azonosító',
						field: 'id',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Vendég',
						field: 'user_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Vendégház',
						field: 'guesthouse_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Érték',
						field: 'price',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Érkezés',
						field: 'arrive_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Távozás',
						field: 'leave_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Létrehozva',
						field: 'created_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Actions',
						field: 'actions',
						width: '15%',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
				c_columns: [
					{
						label: 'Azonosító',
						field: 'id',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Vendég',
						field: 'user_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Vendégház',
						field: 'guesthouse_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Fizetésmód',
						field: 'payment_method_name'
					},
					{
						label: 'Érték',
						field: 'price',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Visszautalás értéke',
						field: 'refund_amount',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Érkezés',
						field: 'arrive_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Távozás',
						field: 'leave_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Létrehozva',
						field: 'created_at',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Actions',
						field: 'actions',
						width: '15%',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
			}
		},
		created() {
			Booking.cancelledBookings()
			.then(response => {
				this.cancelled_bookings = response.data;
			});
			Booking.unpaidBookings()
			.then(response => {
				this.unpaid_bookings = response.data;
			});
		},
		methods: {
			confirmRefund(id){
				Confirmation.swalCustomConfirm('Biztos visszautaltad a foglalást?','Igen').then(response => {
					if(response.isConfirmed === true){
						this.refundBooking(id);
					}
				})
			},
			confirmPaid(id){
				Confirmation.swalCustomConfirm('Biztos megtörtént az utalás?','Igen').then(response => {
					if(response.isConfirmed === true){
						this.BookingPaid(id);
					}
				})
			},
			refundBooking(id){
				Booking.refundedBooking(id)
				.then(() => {
					this.cancelled_bookings.splice(this.cancelled_bookings.findIndex(cb => cb.id == id),1)
				});
			},
			BookingPaid(id){
				Booking.transferBooking(id)
				.then(() => {
					this.unpaid_bookings.splice(this.unpaid_bookings.findIndex(cb => cb.id == id),1)
				});
			},
			downloadExcel(){
				Booking.excel()
				.then(response => {
					var blob=new Blob([response.data]);
					var link=document.createElement('a');
					link.href=window.URL.createObjectURL(blob);
					link.download="dimenzio_lemondott_foglalasok.csv";
					link.click();
				})
			}
		}
	};
</script>